export const dateRegExp = /^\d{4}-\d{2}-\d{2}$/;
export const isDate = (str: string): boolean => dateRegExp.test(str);

export const dateTimeRegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/;
export const isDateTime = (str: string): boolean => dateTimeRegExp.test(str);

export const isoDateTimeRegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
export const isIsoDateTime = (str: string): boolean => isoDateTimeRegExp.test(str);
